var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_478_185",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.526367,
    width: 23.8261,
    height: 29.5719,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_478_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9203 14.0802L2.97831 7.91938V20.241H12.9058V22.7053H2.97831C2.43229 22.7053 1.96487 22.4641 1.57604 21.9815C1.18721 21.4989 0.992798 20.9187 0.992798 20.241V5.45505C0.992798 4.77736 1.18721 4.19722 1.57604 3.71462C1.96487 3.23202 2.43229 2.99072 2.97831 2.99072H18.8624C19.4084 2.99072 19.8758 3.23202 20.2646 3.71462C20.6535 4.19722 20.8479 4.77736 20.8479 5.45505V11.6159H18.8624V7.91938L10.9203 14.0802ZM10.9203 11.6159L18.8624 5.45505H2.97831L10.9203 11.6159ZM18.8624 27.634C17.7703 27.634 16.8355 27.1514 16.0578 26.1862C15.2802 25.221 14.8913 24.0607 14.8913 22.7053V17.1606C14.8913 16.2981 15.1313 15.5691 15.6111 14.9735C16.0909 14.378 16.6783 14.0802 17.3732 14.0802C18.0682 14.0802 18.6555 14.378 19.1354 14.9735C19.6152 15.5691 19.8551 16.2981 19.8551 17.1606V22.7053H17.8696V17.1606C17.8696 16.9963 17.82 16.8526 17.7207 16.7294C17.6214 16.6061 17.5056 16.5445 17.3732 16.5445C17.2409 16.5445 17.125 16.6061 17.0258 16.7294C16.9265 16.8526 16.8769 16.9963 16.8769 17.1606V22.7053C16.8769 23.383 17.0713 23.9632 17.4601 24.4458C17.8489 24.9284 18.3163 25.1697 18.8624 25.1697C19.4084 25.1697 19.8758 24.9284 20.2646 24.4458C20.6535 23.9632 20.8479 23.383 20.8479 22.7053V17.7767H22.8334V22.7053C22.8334 24.0607 22.4445 25.221 21.6669 26.1862C20.8892 27.1514 19.9544 27.634 18.8624 27.634ZM2.97831 7.91938V5.45505V20.241V7.91938Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5cda6112a20029c55a173afa2b465862.svg";
export { ForwardRef as ReactComponent };